import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    TextField,
    Box,
    Typography,
    Grid,
    IconButton,
    Stack,
    Card,
    CircularProgress,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";

const fmt = (n) =>
    n === null || n === undefined || Number.isNaN(Number(n))
        ? "-"
        : Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });

const ReviewWeeklyActualUpdate = ({ open, handleClose, pendingUpdates, handleSubmit, isLoading }) => {
    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden",
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif",
                    }}
                >
                    Review Actual Cost
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        {Object.keys(pendingUpdates).length === 0 && (
                            <Typography>No Updates to Review</Typography>
                        )}
                        {Object.keys(pendingUpdates).length > 0 && (
                            <Box sx={{ mt: 3 }}>
                                <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
                                    Review Updates ({Object.keys(pendingUpdates).length})
                                </Typography>
                                <Stack spacing={1}>
                                    {Object.entries(pendingUpdates).map(([id, data]) => (
                                        <Card
                                            key={id}
                                            variant="outlined"
                                            sx={{ bgcolor: "background.default" }}
                                        >
                                            <Box
                                                sx={{
                                                    p: 1,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <Box>
                                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                                        {data?.label}
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        ID: {id}{" "}
                                                        {data.explicit ? "- Explicitly Update" : ""}
                                                    </Typography>
                                                </Box>
                                                <Stack direction="row" spacing={2} alignItems="center">
                                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                                        ₹{fmt(data.value)}
                                                    </Typography>
                                                </Stack>
                                            </Box>
                                        </Card>
                                    ))}
                                </Stack>

                                <Stack
                                    direction="row"
                                    spacing={1}
                                    sx={{ mt: 2, justifyContent: "flex-end" }}
                                >
                                    <Button
                                        variant="outlined"
                                        color="inherit"
                                        size="small"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        size="small"
                                        onClick={handleSubmit}
                                        disabled={isLoading}
                                        sx={{ display: "flex", gap: 1, alignItems: "center" }}
                                    >
                                        {isLoading && (
                                            <CircularProgress
                                                size={14}
                                                thickness={5}
                                                sx={{ color: "#00344C", ml: 1 }}
                                            />
                                        )}  Submit
                                    </Button>
                                </Stack>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ReviewWeeklyActualUpdate;
